export const filters = {
  role: 'Roles',
  depots: 'Depots',
  status: 'Status',
};

export const systemRole = 'System';
